import FootballState from "../../../../../sports/football/state/football-state";
import { TackleFragmentSerializer } from "./TackleFragmentSerializer";

export class PassSackedFragmentSerializer extends TackleFragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.PassSacked;
    }

    getRawFragment(play, serializationContext, passSacked) {
        return this.getRawFragmentForState(
            play,
            serializationContext,
            FootballState.PassSacked,
            passSacked
        );
    }
}
